var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[(_vm.showBuildVersion)?_c('span',{attrs:{"id":"build-version"}},[_vm._v(" Build Version: "+_vm._s(this.buildVersion)+" ")]):_vm._e(),_c('Header'),_c('v-main',[_c('SideNav'),_c('keep-alive',{attrs:{"exclude":"RMA_DETAIL"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }